export default __webpack_public_path__ + "30628f5a018bfbb8c86ae7d66f1d22b4.png";